import React, { useEffect, useState } from 'react'
import { useMediaQuery } from "react-responsive";
import SideBar from "../components/SideBar";
import { Components } from "../assets/Dimensions";
import { corprateInfos, localCacheRequest,couponconfigInfos } from '../api/CacheAndLogs';
import CacheButton from '../components/CacheButton';
import SwitchComponent from '../components/SwitchComponent';
import './cache.css'
import { ToastContainer,toast } from 'react-toastify';
import ExamCategoryType from '../enums/ExamCategoryType';
import { GetObjectKey } from '../helpers/getObjectKeyFromValue';
import { GetWorklist, SetTransferJob } from '../api/CMS';
import ResponseStatus from '../enums/ResponseStatus';



const Caches = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 700px)' })

    const [nav, setNav] = useState(false);
    const [userId, setUserId] = useState('');
    const [examCategory, setExamCategory] = useState('');
    const [navigationSegmentPageInfov2ClassId, setNavigationSegmentPageInfov2ClassId] = useState('');
    const [navigationSegmentPageInfov2Version, setNavigationSegmentPageInfov2Version] = useState('');
    const [redisNavigationSegmentClassId, setRedisNavigationSegmentClassId] = useState('');
    const [redisNavigationSegmentVersion, setRedisNavigationSegmentVersion] = useState('');
    const [navigationSegmentPageInfoClassId, setNavigationSegmentPageInfoClassId] = useState('');
    const [navigationSplashScreenSegmentClassId, setNavigationSplashScreenSegmentClassId] = useState('');
    const [examCategoryType, setExamCategoryType] = useState('');
    const [corprateData, setCorprateData] = useState();
    const [couponConfigData, setCouponConfigData] = useState();
    const [corprateNames,setCorprateNames] = useState()
    const [selectedName, setSelectedName] = useState('');
    const [selectedConfigType, setSelectedConfigType] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedValue, setSelectedValue] = useState('DevTest');
    const [promotionName, setPromotionName] = useState('');

    // CMS Transfer state
    const [cmsWorklistData, setCmsWorklistData] = useState([]);
    const [selectedTransferGoal, setSelectedTransferGoal] = useState('');
    const [showTransferConfirm, setShowTransferConfirm] = useState(false);
    const [transferConfirmText, setTransferConfirmText] = useState('');
    const [isTransferLoading, setIsTransferLoading] = useState(false);

    const pJWT = sessionStorage.getItem("jwtP");
    const _user = JSON.parse(localStorage.getItem("user"));


    const notify = (notif) =>{
        toast.success(notif)
    }

    const fetchCmsWorklist = async () => {
        try {
            const res = await GetWorklist(_user.Token);
            if (res.data && res.data.ResponseStatus === ResponseStatus.Success) {
                setCmsWorklistData(res.data.ResponseData || []);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleTransferSubmit = async () => {
        if (transferConfirmText !== selectedTransferGoal) return;
        setIsTransferLoading(true);
        try {
            const res = await SetTransferJob(selectedTransferGoal, _user.Token);
            if (res.data && res.data.ResponseStatus === ResponseStatus.Success) {
                toast.success('CMS Transfer işlemi başarıyla başlatıldı.');
            } else {
                toast.error('İşlem başarısız oldu.');
            }
        } catch (e) {
            toast.error('Bir hata oluştu.');
        } finally {
            setIsTransferLoading(false);
            setShowTransferConfirm(false);
            setTransferConfirmText('');
        }
    };

  const handleValueChange = (newValue) => {
    setSelectedValue(newValue);
  };

  const handleRedisPromotionName = (event) => {
    const enteredValue = event.target.value;
    // Use a regular expression to check if the enteredValue is a valid number
   

    // Only update the state if the enteredValue is a valid number
    
        setPromotionName(enteredValue);
    
  }


    const handleInputChange = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setUserId(enteredValue);
        }
    };
    const handleExamCategory = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setExamCategory(enteredValue);
        }
    };

    const handleRedisNavigationSegmentClassId = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setRedisNavigationSegmentClassId(enteredValue);
        }
    }
    const handleRedisNavigationSegmentVersion = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setRedisNavigationSegmentVersion(enteredValue);
        }
    }

    
    const handleNavigationSegmentPageInfov2ClassId = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setNavigationSegmentPageInfov2ClassId(enteredValue);
        }
    }
    const handleNavigationSegmentPageInfov2Version = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setNavigationSegmentPageInfov2Version(enteredValue);
        }
    }
    const handleNavigationSegmentPageInfoClassId = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setNavigationSegmentPageInfoClassId(enteredValue);
        }
    }
    
    const handleNavigationSplashScreenSegmentClassId = (event) => {
        const enteredValue = event.target.value;
        // Use a regular expression to check if the enteredValue is a valid number
        const isValidNumber = /^\d+$/.test(enteredValue);

        // Only update the state if the enteredValue is a valid number
        if (isValidNumber || enteredValue === '') {
            setNavigationSplashScreenSegmentClassId(enteredValue);
        }
    }

    const handleSelectChange = (event) => {
        // Get the selected name from the event
        const selectedName = event.target.value;
        setSelectedName(selectedName);
    
        // Find the corresponding 'Id' from the 'ResponseData' array using the selected name
        const selectedNameData = corprateData.find((item) => item.Name === selectedName);
        if (selectedNameData) {
          // Set the selected 'Id' to the state
          setSelectedId(selectedNameData.Id);
        } else {
          // Handle the case if the selected name is not found (optional)
          setSelectedId(null);
        }
      };

      const handleConfigTypeSelectChange = (event) => {
       
        const selectedConfigType = event.target.value;
        setSelectedConfigType(selectedConfigType);
    
       
      };
    const getCorprateNames = async () =>{
        const res = await corprateInfos(selectedValue=="Admin"?pJWT:_user.Token,selectedValue=="Admin"?true:false);
        if(res.status == 200){
            console.log("what")
            if(res.data.ResponseStatus == 1) {
                console.log("nerdere")
                 //const corpratesFromResponse = res.data.ResponseData?.map((item) => item.Name);
                setCorprateData(res.data.ResponseData)
               // setCorprateNames(corpratesFromResponse)
            }
        }
        console.log(corprateNames)
    }
    const getCouponConfigs = async () =>{
        const res = await couponconfigInfos(selectedValue=="Admin"?pJWT:_user.Token,selectedValue=="Admin"?true:false);
        if(res.status == 200){
            
            if(res.data.ResponseStatus == 1) {
                
                 //const corpratesFromResponse = res.data.ResponseData?.map((item) => item.Name);
                setCouponConfigData(res.data.ResponseData)
               // setCorprateNames(corpratesFromResponse)
            }
        }
        console.log(corprateNames)
    }
    const style = {
        container: {
            //state e bool değer ekle menü butonuna basıldığında css 
            //içinde container a margin eklesin hemde navı açsın

            marginLeft: isTabletOrMobile ? 0 : Components.SideBarWidth + 15,
            paddingTop: 20,
            marginRight: 30,
            marginBottom: 20

        },
    }

    return (
        <div>
            <ToastContainer/>

            {/* CMS Transfer Confirmation Modal */}
            {showTransferConfirm && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000,
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundColor: '#fff', borderRadius: 10, padding: 30,
                        minWidth: 360, maxWidth: 480, boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
                    }}>
                        <h3 style={{ marginTop: 0 }}>CMS Transfer Onayı</h3>
                        <p>
                            Transfer işlemini onaylamak için aşağıya hedef adını (<strong>{selectedTransferGoal}</strong>) yazınız.
                        </p>
                        <input
                            type="text"
                            value={transferConfirmText}
                            onChange={(e) => setTransferConfirmText(e.target.value)}
                            onPaste={(e) => e.preventDefault()}
                            onCopy={(e) => e.preventDefault()}
                            onCut={(e) => e.preventDefault()}
                            onDrop={(e) => e.preventDefault()}
                            placeholder={selectedTransferGoal}
                            style={{
                                width: '100%', padding: '8px 10px', fontSize: 15,
                                borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', marginBottom: 16
                            }}
                        />
                        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                            <button
                                onClick={() => { setShowTransferConfirm(false); setTransferConfirmText(''); }}
                                style={{
                                    padding: '8px 18px', borderRadius: 6, border: '1px solid #ccc',
                                    backgroundColor: '#f3f4f6', cursor: 'pointer'
                                }}
                            >
                                İptal
                            </button>
                            <button
                                onClick={handleTransferSubmit}
                                disabled={transferConfirmText !== selectedTransferGoal || isTransferLoading}
                                style={{
                                    padding: '8px 18px', borderRadius: 6, border: 'none',
                                    backgroundColor: transferConfirmText === selectedTransferGoal ? '#dc2626' : '#fca5a5',
                                    color: '#fff', cursor: transferConfirmText === selectedTransferGoal ? 'pointer' : 'not-allowed'
                                }}
                            >
                                {isTransferLoading ? 'Gönderiliyor...' : 'Onayla'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isTabletOrMobile ?
                <div>
                    <span style={{ "position": "absolute", top: 10, right: 10 }} onClick={() => (setNav(!nav))}>menu</span>
                    {nav && <SideBar />}

                </div>
                : <SideBar />}

            <div style={style.container}>
            <SwitchComponent onValueChange={handleValueChange} />
            
                <div className="table-container">
                    <table className="responsive-table">
                        {/* CMS Transfer - Admin Only */}
                        {_user && _user.Role === 'Administrators' && (
                            <>
                                <thead>
                                    <tr><td colSpan="3" style={{ fontSize: 30 }}>CMS Transfer</td></tr>
                                    <tr>
                                        <th>İşlem</th>
                                        <th>Hedef Seç</th>
                                        <th>Gönder</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>CMS Transfer</td>
                                        <td>
                                            <select
                                                value={selectedTransferGoal}
                                                onChange={(e) => setSelectedTransferGoal(e.target.value)}
                                                style={{ padding: '6px 10px', marginRight: 8, borderRadius: 4, border: '1px solid #ccc' }}
                                            >
                                                <option value="">Hedef Seçiniz...</option>
                                                {cmsWorklistData.map((item, index) => (
                                                    <option key={index} value={item.Name}>{item.Name}</option>
                                                ))}
                                            </select>
                                            <button
                                                onClick={fetchCmsWorklist}
                                                style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', cursor: 'pointer' }}
                                            >
                                                Listele
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                disabled={!selectedTransferGoal}
                                                onClick={() => setShowTransferConfirm(true)}
                                                style={{
                                                    padding: '8px 16px', borderRadius: 6, border: 'none',
                                                    backgroundColor: selectedTransferGoal ? '#dc2626' : '#fca5a5',
                                                    color: '#fff', cursor: selectedTransferGoal ? 'pointer' : 'not-allowed',
                                                    fontWeight: 600
                                                }}
                                            >
                                                Transfer Başlat
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </>
                        )}
                        {/* Local Memory Start */}
                        <thead>
                            <tr><td colSpan="3" style={{ fontSize: 30 }}>Local Memory Cache</td></tr>
                            <tr>
                                <th>Cache İsmi</th>
                                <th>Gerekli Parametreler</th>
                                <th>Cache Kır</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Lectures start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Lectures</td></tr>
                            {/* <tr>
                                <td>All Questions</td>
                                <td></td>
                                <td> <CacheButton notify={notify} apiEndpoint={"allQuestions"} buttonText={"allQuestions"} isAdmin={selectedValue=="Admin"?true:false}/></td>
                            </tr> */}

                            <tr>
                                <td>Lectures</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"lectures"} buttonText={"lectures"} /></td>
                            </tr>
                            <tr>
                                <td>nestedTitles</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"nestedTitles"} buttonText={"nestedTitles"} /></td>
                            </tr>
                            <tr>
                                <td>groupedNestedTitles</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"groupedNestedTitles"} buttonText={"groupedNestedTitles"} /></td>
                            </tr>
                            <tr>
                                <td>nestedAchievements</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"nestedAchievements"} buttonText={"nestedAchievements"} /></td>
                            </tr>
                            <tr>
                                <td>suggestedPlans</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"suggestedPlans"} buttonText={"suggestedPlans"} /></td>
                            </tr>
                            {/* Lectures end */}
                            {/* --------------------------------- */}
                            {/* Lotteries Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Lotteries</td></tr>
                            <tr>
                                <td>lotteries</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"lotteries"} buttonText={"lotteries"} /></td>
                            </tr>
                            <tr>
                                <td>completedLotteries</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"completedLotteries"} buttonText={"completedLotteries"} /></td>
                            </tr>
                            <tr>
                                <td>lotteryConfigs</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"lotteryConfigs"} buttonText={"lotteryConfigs"} /></td>
                            </tr>
                            <tr>
                                <td>lotteryDefinitions</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"lotteryDefinitions"} buttonText={"lotteryDefinitions"} /></td>
                            </tr>
                            <tr>
                                <td>lotteryConfigTypes</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"lotteryConfigTypes"} buttonText={"lotteryConfigTypes"} /></td>
                            </tr>
                            <tr>
                                <td>corporatelotteriesPromotionNames</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"corporatelotteriesPromotionNames"} buttonText={"corporatelotteriesPromotionNames"} /></td>
                            </tr>
                            <tr>
                                <td>corporatelotteries</td>
                                <td>
                                    
                                    {corprateData&&<select value={selectedName} onChange={handleSelectChange}>
                                        <option value="">Select a corprate Name</option>
                                        {corprateData.map((name) => (
                                            <option key={name.Name} value={name.Name}>
                                                {name.Name}
                                            </option>
                                        ))}
                                    </select>}
                                    <button onClick={()=>getCorprateNames()}>
                                        getCorprateNames
                                    </button>
                                </td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`corporatelotteries${selectedId}`} buttonText={"corporatelotteries"} disabled={selectedId == null ?true: false} /></td>
                            </tr>
                            {/* Lotteries end */}
                            {/* --------------------------------- */}
                            {/* Credits Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Credits</td></tr>
                            <tr>
                                <td>clear-user-credit</td>
                                <td> <input
                                placeholder='Please Enter UserId'
                                    type="text"
                                    value={userId}
                                    onChange={handleInputChange}
                                /></td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`clear-user-credit?userId=${userId}`} buttonText={"clear-user-credit?userId=(int)"} isCleanCache={true} disabled={userId.length == 0 ?true: false} /></td>
                            </tr>
                            <tr>
                                <td>clear-all-credits</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"clear-all-credits"} buttonText={"clear-all-credits"} isCleanCache={true} /></td>
                            </tr>
                            {/* Credits End */}
                            {/* --------------------------------- */}
                            {/* Online Lectures Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Online Lectures</td></tr>
                            <tr>
                                <td>clear-online-lecture-by-examcategory YKS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"clear-online-lecture-by-examcategory?examCategoryId=1"} buttonText={"online Lecture YKS"} isCleanCache={true} /></td>
                            </tr>
                            <tr>
                                <td>clear-online-lecture-by-examcategory LGS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"clear-online-lecture-by-examcategory?examCategoryId=2"} buttonText={"online Lecture LGS"} isCleanCache={true} /></td>
                            </tr>
                            <tr>
                                <td>clear-online-lecture (All)</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"clear-online-lecture"} buttonText={"clear-online-lecture"} isCleanCache={true} /></td>
                            </tr>
                            <tr>
                                <td>Live Online Lecture YKS</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_liveonlinelecture_YKS"} buttonText={"_liveonlinelecture_YKS CACHE"}  /></td>
                            </tr>
                            <tr>
                                <td>Live Online Lecture LGS</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_liveonlinelecture_LGS"} buttonText={"_liveonlinelecture_LGS CACHE"}  /></td>
                            </tr>
                            <tr>
                                <td>Live Online Lecture KPSS</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_liveonlinelecture_KPSS"} buttonText={"_liveonlinelecture_KPSS CACHE"}  /></td>
                            </tr>
                            {/* Online Lectures End */}
                            {/* --------------------------------- */}
                            {/* ProductStores Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Product Stores</td></tr>
                            <tr>
                                <td>productStore</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"productStore"} buttonText={"productStore"} /></td>
                            </tr>
                            {/* ProductStores End */}
                            {/* --------------------------------- */}
                            {/* Coupon Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Coupon</td></tr>
                            <tr>
                                <td>couponConfigs</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"couponConfigs"} buttonText={"couponConfigs"} /></td>
                            </tr>
                            <tr>
                                <td>couponConfigTypes</td>
                                <td>
                                {couponConfigData&&<select value={selectedConfigType} onChange={handleConfigTypeSelectChange}>
                                        <option value="">Select a config type</option>
                                        {couponConfigData.map((name) => (
                                            <option key={name.Name} value={name.Name}>
                                                {name.Name}
                                            </option>
                                        ))}
                                    </select>}
                                <button onClick={()=>getCouponConfigs()}>
                                        getCouponConfigs
                                    </button>
                                </td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`getCouponConfigs_${selectedConfigType}`} buttonText={"couponConfigTypes"} disabled={selectedConfigType == null ?true: false} /></td>
                            </tr>
                            <tr>
                                <td>couponDefinitions</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"couponDefinitions"} buttonText={"couponDefinitions"} /></td>
                            </tr>
                            {/* Coupon End */}
                            {/* --------------------------------- */}
                            {/* ProcessUserRankRewardAsync Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>ProcessUserRankRewardAsync</td></tr>
                            <tr>
                                <td>ProcessUserRankRewardsAsync YKS</td>
                                <td> DATA 2</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"ProcessUserRankRewardsAsync_1"} buttonText={"ProcessUserRankRewardsAsync_YKS"} /></td>
                            </tr>
                            <tr>
                                <td>ProcessUserRankRewardsAsync LGS</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"ProcessUserRankRewardsAsync_2"} buttonText={"ProcessUserRankRewardsAsync_LGS"} /></td>
                            </tr>
                            {/* ProcessUserRankRewardAsync End */}
                            {/* --------------------------------- */}
                            {/* TrialExam Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Trial Exams</td></tr>
                            <tr>
                                <td>trialExamCalculations</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamCalculations"} buttonText={"trialExamCalculations"} /></td>
                            </tr>
                            <tr>
                                <td>trialExamLgsCalculations</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamLgsCalculations"} buttonText={"trialExamLgsCalculations"} /></td>
                            </tr>
                            <tr>
                                <td>trialExamLgsQuartiles</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamLgsQuartiles"} buttonText={"trialExamLgsQuartiles"} /></td>
                            </tr>
                            <tr>
                                <td>trialExams</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExams"} buttonText={"trialExams"} /></td>
                            </tr>
                            <tr>
                                <td>trialExamSessionTypes</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamSessionTypes"} buttonText={"trialExamSessionTypes"} /></td>
                            </tr>
                            <tr>
                                <td>trialExamTestQuestions</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamTestQuestions"} buttonText={"trialExamTestQuestions"} /></td>
                            </tr>
                            <tr>
                                <td>trialExamTests</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamTests"} buttonText={"trialExamTests"} /></td>
                            </tr>
                            <tr>
                                <td>cleartrialexam</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"cleartrialexam"} buttonText={"cleartrialexam"} isCleanCache = {true}/></td>
                            </tr>
                            <tr>
                                <td>universityExams</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"universityExams"} buttonText={"universityExams"} /></td>
                            </tr>
                            <tr>
                                <td>trialExamTestPdfs</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamTestPdfs"} buttonText={"trialExamTestPdfs"} /></td>
                            </tr>
                            <tr>
                                <td>trialExamPdfs</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"trialExamPdfs"} buttonText={"trialExamPdfs"} /></td>
                            </tr>
                            {/* TrialExam End */}
                            {/* --------------------------------- */}
                            {/* Configuration Table Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Configuration Table</td></tr>
                            <tr>
                                <td>Configuration Table</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"configurations"} buttonText={"configurations"} /></td>
                            </tr>
                            {/* Configuration Table End */}
                            {/* --------------------------------- */}
                            {/* Navigation Splash Screen Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Navigation Splash Screen</td></tr>
                            <tr>
                                <td>Navigation Splash Screen</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"navigationPageSplashScreen"} buttonText={"navigationPageSplashScreen"} /></td>
                            </tr>
                            <tr>
                                <td>Navigation Splash Screen (new)</td>
                                <td> <input
                                placeholder='Please Enter ExamCategory'
                                    type="text"
                                    value={examCategory}
                                    onChange={handleExamCategory}
                                /></td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`navigationPageSplashScreen_${examCategory}`} buttonText={"navigationPageSplashScreen_(examCategoryId)"}  disabled={examCategory.length == 0 ?true: false} /></td>
                            </tr>
                            <tr>
                                <td>Navigation Splash Screen Segment</td>
                                <td> <input
                                placeholder='Please Enter ClassId'
                                    type="text"
                                    value={navigationSplashScreenSegmentClassId}
                                    onChange={handleNavigationSplashScreenSegmentClassId}
                                /></td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`navigationPageSplashScreen_segment_${navigationSplashScreenSegmentClassId}`} buttonText={"navigationPageSplashScreen_segment_(classId)"}  disabled={navigationSplashScreenSegmentClassId ?false: true} /></td>
                            </tr>
                            <tr>
                                <td>Navigation Segment Page Info</td>
                                <td> <input
                                placeholder='Please Enter ClassId'
                                    type="text"
                                    value={navigationSegmentPageInfoClassId}
                                    onChange={handleNavigationSegmentPageInfoClassId}
                                /></td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`_NAVIGATION_INFO-segment-${navigationSegmentPageInfoClassId}-false`} buttonText={"_NAVIGATION_INFO-segment-(classId)-(LightMode)"}  disabled={navigationSegmentPageInfoClassId ?false: true} /></td>
                            </tr>
                            <tr>
                                <td>Navigation Segment Page Info (DarkModeEnabled)</td>
                                <td> <input
                                placeholder='Please Enter ClassId'
                                    type="text"
                                    value={navigationSegmentPageInfoClassId}
                                    onChange={handleNavigationSegmentPageInfoClassId}
                                /></td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`_NAVIGATION_INFO-segment-${navigationSegmentPageInfoClassId}-true`} buttonText={"_NAVIGATION_INFO-segment-(classId)-(DarkMode)"}  disabled={navigationSegmentPageInfoClassId ?false:true} /></td>
                            </tr>
                            <tr>
                                <td>Navigation Segment Page Info v2</td>
                                <td> 
                                 <input
                                placeholder='Please Enter ClassId'
                                    type="text"
                                    value={navigationSegmentPageInfov2ClassId}
                                    onChange={handleNavigationSegmentPageInfov2ClassId}
                                />
                                 <input
                                placeholder='Please Enter Version'
                                    type="text"
                                    value={navigationSegmentPageInfov2Version}
                                    onChange={handleNavigationSegmentPageInfov2Version}
                                />
                                
                                </td>
                                
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`_NAVIGATION_INFO-segment-${navigationSegmentPageInfov2ClassId}-false-v${navigationSegmentPageInfov2Version}`} buttonText={"_NAVIGATION_INFO-segment-(classId)-(LightMode)-v(version) CACHE"}  disabled={navigationSegmentPageInfov2ClassId && navigationSegmentPageInfov2Version ?false: true} /></td>
                            </tr>
                            <tr>
                                <td>Navigation Segment Page Info v2 (DarkModeEnabled)</td>
                                <td> 
                                <input
                                placeholder='Please Enter ClassId'
                                    type="text"
                                    value={navigationSegmentPageInfov2ClassId}
                                    onChange={handleNavigationSegmentPageInfov2ClassId}
                                />
                                 <input
                                placeholder='Please Enter Version'
                                    type="text"
                                    value={navigationSegmentPageInfov2Version}
                                    onChange={handleNavigationSegmentPageInfov2Version}
                                />
                                </td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`_NAVIGATION_INFO-segment-${navigationSegmentPageInfov2ClassId}-true-v${navigationSegmentPageInfov2Version}`} buttonText={"_NAVIGATION_INFO-segment-(classId)-(DarkMode)-v(version) CACHE"}  disabled={navigationSegmentPageInfov2ClassId && navigationSegmentPageInfov2Version ?false: true} /></td>
                            </tr>
                            {/* Navigation Splash Screen End */}
                            {/* --------------------------------- */}
                            {/* premiumPagePromote Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Premium Page Promote</td></tr>
                            <tr>
                                <td>Premium Page Promote</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"premiumPagePromote"} buttonText={"premiumPagePromote"} /></td>
                            </tr>
                            {/* premiumPagePromote End */}
                            {/* --------------------------------- */}
                            {/* Duello Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Duello lgs </td></tr>
                            <tr>
                                <td>Duello LGS</td>
                                <td>Empty</td>
                                <td>
                                    <CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"https://lgsduello.tosanalytics.com/cache/clear-duello"} buttonText={"LGS Duello"} isDuello={true}/>
                                </td>
                            </tr>
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Duello YKS</td></tr>
                            <tr>
                                <td>Duello YKS</td>
                                <td>Empty</td>
                                <td>
                                    <CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"https://duello.tosanalytics.com/cache/clear-duello"} buttonText={"YKS Duello"} isDuello={true}/>
                                </td>
                            </tr>
                            {/* Duello End */}
                            {/* Live Duello Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Live Duello </td></tr>
                            <tr>
                                <td>Live Duello YKS</td>
                                <td>Empty</td>
                                <td>
                                    <CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_liveduello_YKS"} buttonText={"_liveduello_YKS CACHE"}/>
                                </td>
                            </tr>
                            <tr>
                                <td>Live Duello LGS</td>
                                <td>Empty</td>
                                <td>
                                    <CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_liveduello_LGS"} buttonText={"_liveduello_LGS CACHE"}/>
                                </td>
                            </tr>
                            <tr>
                                <td>Live Duello KPSS</td>
                                <td>Empty</td>
                                <td>
                                    <CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_liveduello_KPSS"} buttonText={"_liveduello_KPSS CACHE"}/>
                                </td>
                            </tr>
                            {/* Live Duello End */}
                            {/* --------------------------------- */}
                            {/* Version Update Config Cache Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Version Update Config Cache</td></tr>
                            <tr>
                                <td>Version Update Config Cache</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"VersionUpdateCheckVersion"} buttonText={"VersionUpdateCheckVersion"} /></td>
                            </tr>
                            {/* Version Update Config Cache End */}
                            {/* --------------------------------- */}
                            {/* content Managment Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>ContentManagement</td></tr>
                            <tr>
                                <td>Clear Navigation Flag</td>
                                <td>Bütün navigation page cachelerini kırar</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"clearnavigationflag"} buttonText={"ClearNavigationFlag"} /></td>
                            </tr>
                            <tr>
                                <td>Content Process</td>
                                <td>s3 de olan bütün dosyaların cache</td>
                                <td>
                                    <CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"https://contentprocess.tosanalytics.com/api/cache/clear?key=s3folders"} buttonText={"contentprocess"} isDuello={true} isContentProcess={true}/>
                                </td>
                            </tr>
                            {/* content Managment End */}
                            {/* Gamification Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Ranking</td></tr>
                            <tr>
                                <td>Ranking Info Response</td>
                                <td>ranking info bilgileri</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"rankingInfosResponse"} buttonText={"rankingInfosResponse"} /></td>
                            </tr>
                            {/* Gamification End */}
                            {/* --------------------------------- */}
                            {/* NavigationPageFlags Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Navigation Page Flags</td></tr>
                            <tr>
                                <td>Old Lottery Flag</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_LOTTERY"} buttonText={"old_NAVIGATION_PAGE_FLAGS_LOTTERY CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Online Lecture Flag YKS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_ONLINELECTURE_YKS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_ONLINELECTURE_YKS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Online Lecture Flag LGS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_ONLINELECTURE_LGS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_ONLINELECTURE_LGS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Online Lecture Flag KPSS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_ONLINELECTURE_KPSS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_ONLINELECTURE_KPSS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Duello Flag YKS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_DUELLO_YKS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_DUELLO_YKS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Duello Flag LGS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_DUELLO_LGS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_DUELLO_LGS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Duello Flag KPSS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_DUELLO_KPSS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_DUELLO_KPSS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Duello Is Active Flag YKS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_YKS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_YKS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Duello Is Active Flag LGS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_LGS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_LGS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Old Duello Is Active Flag KPSS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"old_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_KPSS"} buttonText={"old_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_KPSS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Duello Is Active Flag YKS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_YKS"} buttonText={"_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_YKS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Duello Is Active Flag LGS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_LGS"} buttonText={"_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_LGS CACHE"} /></td>
                            </tr>
                            <tr>
                                <td>Duello Is Active Flag KPSS</td>
                                <td> Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_KPSS CACHE"} buttonText={"_NAVIGATION_PAGE_FLAGS_DUELLO_IS_ACTIVE_KPSS CACHE"} /></td>
                            </tr>
                            {/* NavigationPageFlags End */} 
                            {/* --------------------------------- */} 
                            {/* Calendars Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Calendars</td></tr>
                            <tr>
                                <td>Calendars</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"Calendars"} buttonText={"Calendars"} /></td>
                            </tr>
                            {/* Calendars End */}
                              {/* --------------------------------- */}
                            {/* AssignmentTest Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>AssignmentTest</td></tr>
                            <tr>
                                <td>Assignment Test</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"assignmentTest"} buttonText={"assignmentTest"} /></td>
                            </tr>
                            <tr>
                                <td>Assignment Test Question</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"assignmentTestQuestion"} buttonText={"assignmentTestQuestion"} /></td>
                            </tr>
                            <tr>
                                <td>Assignment Test Question SubCourse Count</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"assignmentTestQuestionSubCourseCount"} buttonText={"assignment Test Question SubCourse Count"} /></td>
                            </tr>
                            {/* AssignmentTest End */}
                            {/* --------------------------------- */}

                            {/* New Caches Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Navigation and Trial caches</td></tr>
                            <tr>
                                <td>TrailExams</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"cleartrialexam"} buttonText={"cleartrialexam"} isCleanCache={true} /></td>
                            </tr>
                            <tr>
                                <td>NavigationPAge</td>
                                <td>Empty</td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"clearnavigationflag"} buttonText={"media/clearnavigationflag"} isCleanCache={true} /></td>
                            </tr>
                            
                            {/* New Caches End */}
                            {/* --------------------------------- */}
                            {/* Local Memory end */}
                            {/* -------------------------------------------------------------- */}
                            {/* Redis Cache Start */}
                        </tbody>
                        <tr><td colSpan="3" style={{ fontSize: 30 }}>Redis Cache</td></tr>
                        <thead >
                            <tr>
                                <th>Redis Key</th>
                                <th>Database</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>

                            {/* promotion Name Start */}
                          
                            <tr>
                                <td>Promotion name Redis Cache</td>
                                <td><input
                                placeholder='Please Enter PromotionName'
                                    type="text"
                                    value={promotionName}
                                    onChange={handleRedisPromotionName}
                                /></td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`deleterediscache?key=${promotionName}&database=9`} buttonText={"Delete Promotion Redis Cache"} isRedis={true} disabled={promotionName.length == 0 ?true: false}/></td>
                            </tr>
                            {/* promotion Name end */}

                            {/* --------------------------------- */}
                            {/* Trial Exams Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Trial Exams</td></tr>
                            <tr>
                                <td>LGS_CALCULATION_STATE</td>
                                <td>TrialExam</td>
                                <td>son hesaplama durumu</td>
                            </tr>
                            <tr>
                                <td>LGS_LAST_CALCULATION_TIME</td>
                                <td>TrialExam</td>
                                <td>son hesaplama süresi</td>
                            </tr>
                            <tr>
                                <td>LGS_NET_(trialExamId)</td>
                                <td>TrialExam</td>
                                <td>lgs neti</td>
                            </tr>
                            <tr>
                                <td>LGS_QUARTILE_(trialExamId)_(quartile.Year)</td>
                                <td>TrialExam</td>
                                <td>deneme sınavı lgs çeyrekleri</td>
                            </tr>
                            <tr>
                                <td>LGS_RANK_(trailExamId)_(quartile.Year)</td>
                                <td>TrialExam</td>
                                <td>lgs sıralaması</td>
                            </tr>
                            <tr>
                                <td>LGS_TO_CALCULATE_EXAMS</td>
                                <td>TrialExam</td>
                                <td>kullanıcı sınavı bitirince hesaplaması</td>
                            </tr>
                            <tr>
                                <td>TRIALEXAM_PARTICIPANT_(trailExamId)</td>
                                <td>TrialExam</td>
                                <td>deneme sınavı katılımcıları</td>
                            </tr>
                            {/* Trial Exams End */}
                            {/* --------------------------------- */}
                            {/* TestSection Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>TestSection</td></tr>
                            <tr>
                                <td>DAILY_TESTSECTIONS_COUNT</td>
                                <td>TestSection</td>
                                <td>Empty</td>
                            </tr>
                            <tr>
                                <td>TESTSECTIONS_TESTSECTIONELEMENTSTATS</td>
                                <td>TestSection</td>
                                <td>Empty</td>
                            </tr>
                            <tr>
                                <td>TESTSECTIONS_TESTSECTIONELEMENTSTATS_HASHSET</td>
                                <td>TestSection</td>
                                <td>testlerin hashlenip getirilmiş hali</td>
                            </tr>
                            {/* TestSection End */}
                            {/* --------------------------------- */}
                            {/* Restrictions Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Restrictions</td></tr>
                            <tr>
                                <td>DEVICE_RESTRICTION_TEST_SECTIONS</td>
                                <td>Restriction</td>
                                <td>cihaz kısıtlamaları</td>
                            </tr>
                            <tr>
                                <td>USER_RESTRICTION_TEST_SECTIONS</td>
                                <td>Restriction</td>
                                <td>kullanıcı kısıtlamalı testler</td>
                            </tr>
                            {/* Restrictions End */}
                            {/* --------------------------------- */}
                            {/* OnlineLectures Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Online Lectures</td></tr>
                            <tr>
                                <td>_ONLINE_LECTURE_PREMIUM_LIST_1</td>
                                <td>OnlineLecture</td>
                                <td>YKS premium listesi</td>
                            </tr>
                            <tr>
                                <td>_ONLINE_LECTURE_FREE_LIST_1</td>
                                <td>OnlineLecture</td>
                                <td>YKS free listesi</td>
                            </tr>
                            <tr>
                                <td>_ONLINE_LECTURE_PREMIUM_LIST_2</td>
                                <td>OnlineLecture</td>
                                <td>LGS premium listesi</td>
                            </tr>
                            <tr>
                                <td>_ONLINE_LECTURE_FREE_LIST_2</td>
                                <td>OnlineLecture</td>
                                <td>LGS free listesi </td>
                            </tr>
                            <tr>
                                <td>clear-online-lecture</td>
                                <td>OnlineLecture</td>
                                <td>genel canlı dershane listesi</td>
                            </tr>
                            {/* OnlineLectures End */}
                            {/* --------------------------------- */}
                            {/* Lottery Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Lottery</td></tr>
                            <tr>
                                <td>CORPORATE_LOTTERY_TOTALTICKETCOUNT_(continuingLotteryId)</td>
                                <td>Lottery</td>
                                <td>kurumsal çekilişin toplam ticket'ı</td>
                            </tr>
                            <tr>
                                <td>CORPORATE_LOTTERY_USERTICKET_(userId)</td>
                                <td>Lottery</td>
                                <td>kurumsal çekilişe katılan kullanıcıların tekil puanları</td>
                            </tr>
                            <tr>
                                <td>LOTTERY_TOTALTICKETCOUNT_(continuingLotteryId)</td>
                                <td>Lottery</td>
                                <td>çekilişin toplam ticket'ı</td>
                            </tr>
                            <tr>
                                <td>LOTTERY_USERTICKET_(userId)</td>
                                <td>Lottery</td>
                                <td>çekilişe katılan kullanıcıların tekil puanları</td>
                            </tr>
                            {/* Lottery End */}
                            {/* --------------------------------- */}
                            {/* Invitation Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Invitation</td></tr>
                            <tr>
                                <td>INVITATION_CODES</td>
                                <td>Invitation</td>
                                <td>invite kodları</td>
                            </tr>
                            <tr>
                                <td>INVITATION_REGISTERED_DEVICES</td>
                                <td>Invitation</td>
                                <td>invite kayıtlı cihazlar</td>
                            </tr>
                            <tr>
                                <td>INVITATION_TOTAL_COUNT</td>
                                <td>Invitation</td>
                                <td>toplam davet kodu</td>
                            </tr>
                            <tr>
                                <td>INVITATION_USER_DATA</td>
                                <td>Invitation</td>
                                <td>kullanıcının invite kodu</td>
                            </tr>
                            {/* Invitation End */}
                            {/* --------------------------------- */}
                            {/* FortuneOfWheel Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>FortuneOfWheel</td></tr>
                            <tr>
                                <td>_FORTUNE_OF_WHEEL</td>
                                <td>FortuneOfWheel</td>
                                <td>Empty</td>
                            </tr>
                            <tr>
                                <td>_FORTUNE_OF_WHEEL_BOX_GIFT-(userId)</td>
                                <td>FortuneOfWheel</td>
                                <td>çarkdaki hediyesi</td>
                            </tr>
                            <tr>
                                <td>_FORTUNE_OF_WHEEL_DISCOUNTED_GIFT-(userId)</td>
                                <td>FortuneOfWheel</td>
                                <td>indirim kazanan kullanıcı</td>
                            </tr>
                            <tr>
                                <td>_FORTUNE_OF_WHEEL_GIFT</td>
                                <td>FortuneOfWheel</td>
                                <td>Empty</td>
                            </tr>
                            <tr>
                                <td>_FORTUNE_OF_WHEEL_USER_GIFT-(userId)@(fortuneSectionType)</td>
                                <td>FortuneOfWheel</td>
                                <td>kullanıcının kazandığı hediye</td>
                            </tr>
                            <tr>
                                <td>_GIFT2WIN-(userId)</td>
                                <td>FortuneOfWheel</td>
                                <td>kullanıcının kazanacak olduğu hediye</td>
                            </tr>
                            {/* FortuneOfWheel End */}
                            {/* --------------------------------- */}
                            {/* Coupon Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Coupon</td></tr>
                            <tr>
                                <td>COUPON_USER_ADS_RESTRICTION-(userId)</td>
                                <td>Coupon</td>
                                <td>kullanıcı kupon reklamları kısıtlaması</td>
                            </tr>
                            <tr>
                                <td>COUPON_USER_ADS_RESTRICTION_COUNT-(userId)</td>
                                <td>Coupon</td>
                                <td>kupon kullanıcı reklamları kısıtlama sayısı</td>
                            </tr>
                            <tr>
                                <td>COUPON_USERCOUPONS</td>
                                <td>Coupon</td>
                                <td>kullanıcı kuponları</td>
                            </tr>
                            {/* Coupon End */}
                            {/* --------------------------------- */}
                            {/* Content Managment Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>ContentManagement</td></tr>
                            <tr>
                                <td>_NAVIGATION_INFO-oldversion-1-true&database=ContentManagement(OLD VERSİON YKS Light Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-oldversion-1-true&database=ContentManagement"} buttonText={"OLD VERSİON YKS Light Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-oldversion-1-false&database=ContentManagement(OLD VERSİON YKS DARK Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-oldversion-1-false&database=ContentManagement"} buttonText={"OLD VERSİON YKS DARK Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-newversion-1-true&database=ContentManagement(OLD VERSİON YKS Light Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-newversion-1-true&database=ContentManagement"} buttonText={"NEW VERSİON YKS Light Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-newversion-1-false&database=ContentManagement(OLD VERSİON YKS DARK Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-newversion-1-false&database=ContentManagement"} buttonText={"NEW VERSİON YKS DARK Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-oldversion-2-true&database=ContentManagement(LGS Light Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-oldversion-2-true&database=ContentManagement"} buttonText={"OLD VERSİON LGS Light Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-oldversion-2-false&database=ContentManagement(LGS DARK Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-oldversion-2-false&database=ContentManagement"} buttonText={"OLD VERSİON LGS DARK Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-newversion-2-true&database=ContentManagement(LGS Light Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-newversion-2-true&database=ContentManagement"} buttonText={"NEW VERSİON LGS Light Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-newversion-2-false&database=ContentManagement(LGS DARK Mode)</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_INFO-newversion-2-false&database=ContentManagement"} buttonText={"NEW VERSİON LGS DARK Mode"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_DUELLO1&database=ContentManagement(YKS)</td>
                                <td>duello için yanıp sönen top</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_DUELLO1&database=ContentManagement"} buttonText={"YKS DUELLO FLAG"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_DUELLO2&database=ContentManagement(LGS)</td>
                                <td>duello için yanıp sönen top</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_DUELLO2&database=ContentManagement"} buttonText={"LGS DUELLO FLAG"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_LOTTERY&database=ContentManagement</td>
                                <td>çekiliş için yanıp sönen top</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_LOTTERY&database=ContentManagement"} buttonText={"LOTTERY FLAG"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_ONLINELECTURE-1&database=ContentManagement(YKS)</td>
                                <td>canlı dershane için yanıp sönen top</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_ONLINELECTURE-1&database=ContentManagement"} buttonText={"YKS ONLİNE LECTURE FLAG"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_ONLINELECTURE-2&database=ContentManagement(LGS)</td>
                                <td>canlı dershane için yanıp sönen top</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"_NAVIGATION_PAGE_FLAGS_ONLINELECTURE-2&database=ContentManagement"} buttonText={"LGS ONLİNE LECTURE FLAG"} isRedis={true}/></td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_INFO-oldversion-(ExamCategoryId)-(IsDarkModeEnable)</td>
                                <td>ContentManagement</td>
                                <td>Ana sayfada menülerin yerleri, görselleri ve yazıları</td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_DUELLO(examCategoryId)</td>
                                <td>ContentManagement</td>
                                <td>duello için yanıp sönen top</td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_LOTTERY</td>
                                <td>ContentManagement</td>
                                <td>çekiliş için yanıp sönen top</td>
                            </tr>
                            <tr>
                                <td>_NAVIGATION_PAGE_FLAGS_ONLINELECTURE-(examCategoryId)</td>
                                <td>ContentManagement</td>
                                <td>canlı dershane için yanıp sönen top</td>
                            </tr>
                            <tr>
                                <td>CONTENT_MANAGEMENT_NAVIGATION_SEGMENT</td>
                                <td> 
                                 <input
                                placeholder='Please Enter ClassId'
                                    type="text"
                                    value={navigationSegmentPageInfov2ClassId}
                                    onChange={handleRedisNavigationSegmentClassId}
                                />
                                 <input
                                placeholder='Please Enter Version'
                                    type="text"
                                    value={navigationSegmentPageInfov2Version}
                                    onChange={handleRedisNavigationSegmentVersion}
                                />
                                
                                </td>
                                
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`CONTENT_MANAGEMENT_NAVIGATION-segment-${redisNavigationSegmentClassId}-false-v${redisNavigationSegmentVersion}`} buttonText={"_NAVIGATION_INFO-segment-(classId)-(LightMode)-v(version) CACHE"}  disabled={redisNavigationSegmentClassId && redisNavigationSegmentVersion ?false: true} /></td>
                            </tr>
                            <tr>
                                <td>CONTENT_MANAGEMENT_NAVIGATION_SEGMENT (DarkModeEnabled)</td>
                                <td> 
                                <input
                                placeholder='Please Enter ClassId'
                                    type="text"
                                    value={navigationSegmentPageInfov2ClassId}
                                    onChange={handleRedisNavigationSegmentClassId}
                                />
                                 <input
                                placeholder='Please Enter Version'
                                    type="text"
                                    value={navigationSegmentPageInfov2Version}
                                    onChange={handleRedisNavigationSegmentVersion}
                                />
                                </td>
                                <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={`CONTENT_MANAGEMENT_NAVIGATION-segment-${redisNavigationSegmentClassId}-true-v${redisNavigationSegmentVersion}`} buttonText={"_NAVIGATION_INFO-segment-(classId)-(DarkMode)-v(version) CACHE"}  disabled={redisNavigationSegmentClassId && redisNavigationSegmentVersion ?false: true} isRedis={true}/></td>
                            </tr>
                            {/* Content Managment End */}
                            {/* --------------------------------- */}
                            {/* UserRanks Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>UserRanks</td></tr>
                            <tr>
                                <td>CACHING_KEY_TOTAL_SOLVED_WEEKLY(examCategoryId)</td>
                                <td>UserRanks</td>
                                <td>haftalık çözülen soru sayısı</td>
                            </tr>
                            <tr>
                                <td>USER_RANKS_CORRECTSOLVED_(examCategoryId)(date)</td>
                                <td>UserRanks</td>
                                <td>kullanıcının doğru çözdüğü </td>
                            </tr>
                            <tr>
                                <td>USER_RANKS_CORRECTSOLVED_WEEKLY(examCategoryId)</td>
                                <td>UserRanks</td>
                                <td>kullanıcının doğru çözdüğü haftalık sorular</td>
                            </tr>
                            <tr>
                                <td>USER_RANKS_POINT_(examCategoryId)(date)</td>
                                <td>UserRanks</td>
                                <td>kullanıcı sıralama puanı</td>
                            </tr>
                            <tr>
                                <td>USER_RANKS_POINT_WEEKLY(examCategoryId)(date)</td>
                                <td>UserRanks</td>
                                <td>kullanıcının haftalık sıralama puanı</td>
                            </tr>
                            <tr>
                                <td>USER_RANKS_TOTALSOLVED_(examCategoryId)(date)</td>
                                <td>UserRanks</td>
                                <td>kullanıcının çözdüğü sorular</td>
                            </tr>
                            <tr>
                                <td>USER_RANKS_TOTALSOLVED_WEEKLY(examCategoryId)</td>
                                <td>UserRanks</td>
                                <td>kullanıcının haftalık çözdüğü sorular</td>
                            </tr>
                            {/* UserRanks End */}
                            {/* --------------------------------- */}
                            {/* Account Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>Account</td></tr>
                            <tr>
                                <td>{`PHONE_CONFIRMATION_{userId}`}</td>
                                <td>Account</td>
                                <td>Empty</td>
                            </tr>
                            {/* Account End */}
                            {/* --------------------------------- */}
                            {/* EmailVerifications Start */}
                            <tr><td colSpan="2" style={{ fontSize: 25 }}>EmailVerifications</td></tr>
                            <tr>
                                <td>EMAIL_VERIFICATION_CODES</td>
                                <td>EmailVerifications</td>
                                <td>Empty</td>
                            </tr>
                            {/* EmailVerifications End */}
                            {/* --------------------------------- */}
                            {/* Gamification Start */}
                             <tr><td colSpan="2" style={{ fontSize: 25 }}>Gamification</td></tr>
                            <tr>
                                <td>NET_DAILY_examCategoryId_mm/DD/yyyy</td>
                                <td>NET_DAILY_</td>
                                <td>haftalık çözülen soru sayısı</td>
                            </tr>
                            <tr>
                                <td>NET_WEEKLY_(examCategoryId)_year_weekOfYear</td>
                                <td>NET_WEEKLY</td>
                                <td>haftalık net bilgisi</td>
                            </tr>
                            <tr>
                                <td>NET_MOTNHLY_(examCategoryId)_year_month</td>
                                <td>UserRanks</td>
                                <td>kullanıcının doğru çözdüğü haftalık sorular</td>
                            </tr>
                            <tr>
                                <td>USER_RANKS_POINT_(examCategoryId)(date)</td>
                                <td>NET_MONTHLY</td>
                                <td>aylık net bilgisi</td>
                            </tr>
                            <tr>
                                <td>DAILY_(examCategoryId)_mm/DD/yyyy</td>
                                <td>DAILY_</td>
                                <td>günlük puan bilgisi</td>
                            </tr>
                            <tr>
                                <td>WEEKLY_(examCategoryId)_year_weekOfYear</td>
                                <td>WEEKLY_</td>
                                <td>haftalık puan bilgisi</td>
                            </tr>
                            <tr>
                                <td>MONTHLY_(examCategoryId)_year_month</td>
                                <td>MONTHLY_</td>
                                <td>aylık puan bilgisi</td>
                            </tr>
                            <tr>
                                <td>RANKING_INFO</td>
                                <td>duello için redise rankingreward bilgisi girilir</td>
                                  <td><CacheButton notify={notify} isAdmin={selectedValue=="Admin"?true:false} apiEndpoint={"RANKING_INFO"} buttonText={"RANKING_INFO"} isRedis={true}/></td>
                            </tr>
                            {/* Gamification End */}
                            {/* Redis Cache End */}
                        </tbody>
                    </table>
                </div>
            </div>
           
        </div>
    )
}

export default Caches